import { Link } from 'react-router-dom';
import { CHANNEL_LABEL, elapsedShort, type RescueRowDto } from '@coachrex/shared';
import { money } from '../lib/format';
import { Chip, GradeBadge } from './ui';
import '../pages/conversations.css';
import '../pages/rescue.css';

/** One at-risk lead. Shared by Rescue and Overview (grid `96px 1.3fr 2fr 84px 50px 150px`). */
export function RescueRow({
  r,
  currency,
  watching,
  onOpenCrm,
  onUpdate,
}: {
  r: RescueRowDto;
  currency: string;
  watching: boolean;
  onOpenCrm: (r: RescueRowDto) => void;
  onUpdate: (r: RescueRowDto) => void;
}) {
  const active = r.status === 'open' || r.status === 'completed';
  return (
    <div className="list-row rescue-grid">
      <span>
        <Chip tone={r.priority === 'high' ? 'red' : 'amber'}>{r.priority === 'high' ? 'High value' : 'Follow up'}</Chip>
      </span>
      <Link to={`/conversations/${r.leadId}`} className="convo-lead" style={{ color: 'inherit' }}>
        <GradeBadge grade={r.grade} size={26} />
        <span className="convo-lead__text">
          <span className="convo-lead__name">{r.leadName}</span>
          <span className="convo-lead__rep">with {r.rep?.name ?? 'Nobody assigned'}</span>
        </span>
      </Link>
      <span className="rescue-why">
        <span>{r.reason}</span>
        <span className="rescue-why__meta">
          <span className="chan-chip">{CHANNEL_LABEL[r.channel]}</span>
          <span style={{ color: watching ? 'var(--accent-text)' : undefined }}>{watching ? 'Watching CRM for activity…' : r.statusLine}</span>
        </span>
      </span>
      <span className="num" style={{ fontWeight: 600 }}>
        {money(r.value, currency)}
      </span>
      <span className="num" style={{ color: 'var(--faint)', fontSize: 12.5 }}>
        {elapsedShort(Date.now() - Date.parse(r.since))}
      </span>
      <span className="rescue-actions">
        {active && (
          <button className={`btn btn--sm ${watching ? 'btn--secondary' : 'btn--accent'}`} onClick={() => onOpenCrm(r)}>
            {watching ? 'Watching…' : 'Open in CRM'}
          </button>
        )}
        <button className="link-btn" onClick={() => onUpdate(r)}>
          Update manually
        </button>
      </span>
    </div>
  );
}
